// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"7e24f1df","453":"1740ceb4"}[chunkId] + ".chunk.js";
};